/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20SchemaDefinition } from '../../asyncapi/v2/models/Aai20SchemaDefinition';
import { Document } from '../../core/models/Document';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';
import { AaiSchema } from '../../asyncapi/models/AaiSchema';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Node } from '../../core/models/Node';

/**
 * A command used to replace a definition schema with a newer version.
 * @author vvilerio
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplaceSchemaDefinitionCommand_Aai20 extends ReplaceNodeCommand<Aai20SchemaDefinition> {
    public _defName : string;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>Aai20SchemaDefinition) || old === null) && ((replacement != null && replacement instanceof <any>Aai20SchemaDefinition) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
            if(this._defName===undefined) this._defName = null;
            if(this._defName===undefined) this._defName = null;
            (() => {
                this._defName = old.getName();
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._defName===undefined) this._defName = null;
            if(this._defName===undefined) this._defName = null;
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_v2_models_Aai20SchemaDefinition(doc : Document, node : Aai20SchemaDefinition) {
        let doc20 : Aai20Document = <Aai20Document>doc;
        doc20.components.removeSchemaDefinition(node.getName());
    }

    /**
     * @see ReplaceNodeCommand#removeNode(Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Aai20SchemaDefinition} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Aai20SchemaDefinition) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_v2_models_Aai20SchemaDefinition(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_v2_models_Aai20SchemaDefinition(doc : Document, node : Aai20SchemaDefinition) {
        let doc20 : Aai20Document = <Aai20Document>doc;
        node._ownerDocument = doc;
        node._parent = doc20.components;
        doc20.components.addSchemaDefinition(node.getName(), node);
    }

    /**
     * @see ReplaceNodeCommand#addNode(Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Aai20SchemaDefinition} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Aai20SchemaDefinition) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_asyncapi_v2_models_Aai20SchemaDefinition(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see ReplaceNodeCommand#readNode(Document, Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Aai20SchemaDefinition}
     */
    readNode(doc : Document, node : any) : Aai20SchemaDefinition {
        let doc20 : Aai20Document = <Aai20Document>doc;
        let definition : Aai20SchemaDefinition = doc20.components.createSchemaDefinition(this._defName);
        Library.readNode(node, definition);
        return definition;
    }
}
ReplaceSchemaDefinitionCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceSchemaDefinitionCommand_Aai20";
ReplaceSchemaDefinitionCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




